import ROUTES from '../routes';
import IndividualClientsRisk from '../hoc/indiviual-clients-risk/individual-clients-risk';
import GeographicalIndividualClientsRisk from '../hoc/indiviual-clients-risk/geogrpahical';
import IndividualVolumes from '../hoc/indiviual-clients-risk/volumes/volumes-list';
import IndividuaVolumesForm from '../hoc/indiviual-clients-risk/volumes/volumes-form';
import IndividualClientsProductsList from '../hoc/indiviual-clients-risk/products/products';
import IndividualProductForm from '../hoc/indiviual-clients-risk/products/form';
import IndividualDeliveryChannels from '../hoc/indiviual-clients-risk/delivery-channels/list';
import IndividualDeliveryChannelForm from '../hoc/indiviual-clients-risk/delivery-channels/form';
import IndividualClientsActivitiesList from '../hoc/indiviual-clients-risk/clients-activities/clients-activities';
import IndividualClientsActivitiesForm from '../hoc/indiviual-clients-risk/clients-activities/form';
import IndividualClientsSourceOfFundsList from '../hoc/indiviual-clients-risk/source-of-funds/source-of-funds';
import IndividualClientsSourceOfFundsForm from '../hoc/indiviual-clients-risk/source-of-funds/form';

const IndividualClientsRiskRoutes = {
  path: ROUTES.INDIVIDUAL_CLIENTS_RISK,
  element: <IndividualClientsRisk />,
  children: [
    {
      path: ROUTES.INDIVIDUAL_CLIENTS_RISK_GEOGRAPHICAL,
      element: <GeographicalIndividualClientsRisk />,
    },
    {
      path: ROUTES.INDIVIDUAL_CLIENTS_RISK_VOLUMES,
      element: <IndividualVolumes />,
      children: [
        {
          path: ROUTES.INDIVIDUAL_CLIENTS_RISK_VOLUMES_CREATE,
          element: <IndividuaVolumesForm />,
        },
        {
          path: ROUTES.INDIVIDUAL_CLIENTS_RISK_VOLUMES_EDIT,
          element: <IndividuaVolumesForm />,
        },
      ],
    },
    {
      path: ROUTES.INDIVIDUAL_CLIENTS_RISK_PRODUCTS,
      element: <IndividualClientsProductsList />,
      children: [
        {
          path: ROUTES.INDIVIDUAL_CLIENTS_RISK_PRODUCTS_CREATE,
          element: <IndividualProductForm />,
        },
        {
          path: ROUTES.INDIVIDUAL_CLIENTS_RISK_PRODUCTS_EDIT,
          element: <IndividualProductForm />,
        },
      ],
    },
    {
      path: ROUTES.INDIVIDUAL_CLIENTS_RISK_DELIVERY_CHANNELS,
      element: <IndividualDeliveryChannels />,
      children: [
        {
          path: ROUTES.INDIVIDUAL_CLIENTS_RISK_DELIVERY_CHANNELS_CREATE,
          element: <IndividualDeliveryChannelForm />,
        },
        {
          path: ROUTES.INDIVIDUAL_CLIENTS_RISK_DELIVERY_CHANNELS_EDIT,
          element: <IndividualDeliveryChannelForm />,
        },
      ],
    },
    {
      path: ROUTES.INDIVIDUAL_CLIENTS_RISK_ACTIVITIES,
      element: <IndividualClientsActivitiesList />,
      children: [
        {
          path: ROUTES.INDIVIDUAL_CLIENTS_RISK_ACTIVITIES_CREATE,
          element: <IndividualClientsActivitiesForm />,
        },
        {
          path: ROUTES.INDIVIDUAL_CLIENTS_RISK_ACTIVITIES_EDIT,
          element: <IndividualClientsActivitiesForm />,
        },
      ],
    },
    {
      path: ROUTES.INDIVIDUAL_CLIENTS_RISK_SOURCE_OF_FUNDS,
      element: <IndividualClientsSourceOfFundsList />,
      children: [
        {
          path: ROUTES.INDIVIDUAL_CLIENTS_RISK_SOURCE_OF_FUNDS_CREATE,
          element: <IndividualClientsSourceOfFundsForm />,
        },
        {
          path: ROUTES.INDIVIDUAL_CLIENTS_RISK_SOURCE_OF_FUNDS_EDIT,
          element: <IndividualClientsSourceOfFundsForm />,
        },
      ],
    },
  ],
};

export default IndividualClientsRiskRoutes;
